import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';

/**
 * Finds the sharing permission object checking the email address.
 * @param permissions List of Sharing Permissions
 * @param item Current Sharing Permission
 */
export default function(
    permissions: SharingPermissionItemState[],
    item: SharingPermissionItemState
): SharingPermissionItemState[] {
    let filteredPermissions =
        permissions &&
        permissions.filter(function(itemInArray: SharingPermissionItemState) {
            return (
                itemInArray.EmailAddress &&
                item.EmailAddress &&
                itemInArray.EmailAddress.EmailAddress == item.EmailAddress.EmailAddress
            );
        });
    return filteredPermissions;
}
